/* tslint:disable */

/**
 *
 * @class Job
 *
 * model for a sync job
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      November 2022
 *
 */
export class Job {

  /** job OID */
  public id: string;

  /** job status */
  public status: string;

  /** meta data */
  public meta: {

    output: string[],

    metrics: {
      total: number,
      enabled: number,
      disabled: number
    },

    progress: number,

    warnings: string[]
  };

  /** did we error out? */
  public error: string;

  /** how many seconds it took */
  public duration: number;

  /** who triggered it */
  public author: string;

  /** time stamps */
  public created_at: Date;
  public updated_at: Date;

  /** standard constructor */
  public constructor (init?: Partial<Job>) {

    if (init.duration && (typeof init.duration == 'string')) {

      init.duration = Number(init.duration);
    }

    Object.assign(this, init);
  }
}
